import { __decorate, __metadata } from "tslib";
import { lazyAppContextConsumer } from '@1inch-community/core/lazy';
import { translate } from '@1inch-community/core/lit-utils';
import { parseChainId } from '@1inch-community/sdk/chain';
import { destructuringId } from '@1inch-community/sdk/tokens';
import '@1inch-community/ui-components/button';
import '@1inch-community/ui-components/icon';
import '@1inch-community/ui-components/marquee';
import '@1inch-community/ui-components/text-animate';
import { Task } from '@lit/task';
import { html, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { when } from 'lit/directives/when.js';
import '../../token-icon';
import { changeExpand } from '../events';
import { calculateSize } from '../sizes';
import { tokenItemBaseHostStyle } from '../token-item-base';
import './token-item-cross-chain-accordion-chain-list';
let TokenItemCrossChainAccordionElement = class TokenItemCrossChainAccordionElement extends LitElement {
    constructor() {
        super(...arguments);
        this.showFavoriteTokenToggle = false;
        this.expanded = false;
        this.mobileView = false;
        this.index = 0;
        this.showMoreChain = false;
        this.applicationContext = lazyAppContextConsumer(this);
        this.task = new Task(this, async ([crossChainTokensBindingRecord, walletAddress, showChainIds]) => {
            if (!crossChainTokensBindingRecord || !showChainIds)
                throw new Error('');
            const { symbol } = crossChainTokensBindingRecord;
            const [tokenName, tokenIdListWithBalance] = await Promise.all([
                this.applicationContext.value.tokenStorage.getCrossChainTokenName({ symbol }),
                walletAddress
                    ? this.applicationContext.value.tokenStorage.getCrossChainTokenIdListWithBalance({
                        chainIds: showChainIds ?? [],
                        walletAddress,
                        symbol,
                    })
                    : null,
            ]);
            const tokenIdWithBalanceSet = new Set(tokenIdListWithBalance ?? []);
            const tokenIdListWithoutBalance = crossChainTokensBindingRecord.tokenRecordIds.filter((id) => !tokenIdWithBalanceSet.has(id));
            const chainIds = crossChainTokensBindingRecord.tokenRecordIds.map((id) => {
                const [chainIdStr] = destructuringId(id);
                return parseChainId(chainIdStr);
            });
            if (tokenIdWithBalanceSet.size === 0) {
                this.showMoreChain = true;
            }
            return [
                crossChainTokensBindingRecord,
                tokenName,
                chainIds,
                tokenIdListWithoutBalance,
                tokenIdListWithBalance,
            ];
        }, () => [this.crossChainTokensBindingRecord, this.walletAddress, this.showChainIds]);
    }
    static { this.tagName = 'inch-token-item-cross-chain-accordion'; }
    static { this.styles = tokenItemBaseHostStyle; }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.expanded) {
            changeExpand(this);
        }
    }
    render() {
        return this.task.render({
            pending: () => this.renderTokenViewOrLoader(),
            error: () => this.renderTokenViewOrLoader(),
            complete: () => this.renderTokenViewOrLoader(),
        });
    }
    renderTokenViewOrLoader() {
        const [crossChainTokensBindingRecord, tokenName, chainIds, tokenIdListWithoutBalance, tokenIdListWithBalance,] = this.task.value ?? [];
        return this.renderTokenView(crossChainTokensBindingRecord, tokenName, chainIds, tokenIdListWithoutBalance, tokenIdListWithBalance);
    }
    renderTokenView(crossChainTokensBindingRecord, tokenName, chainIds, tokenIdListWithoutBalance, tokenIdListWithBalance) {
        const { symbol } = crossChainTokensBindingRecord ?? {};
        if (!this.expanded) {
            this.showMoreChain = false;
        }
        const tokenNetworkText = crossChainTokensBindingRecord
            ? this.renderNetworkDescription(crossChainTokensBindingRecord)
            : undefined;
        let size = 0;
        if (this.expanded && tokenIdListWithoutBalance && tokenIdListWithBalance !== undefined) {
            size = calculateSize(this.showMoreChain, tokenIdListWithoutBalance, tokenIdListWithBalance);
        }
        let iconAfterStyle = {
            transform: 'rotate(-90deg)',
        };
        if (size !== 0) {
            iconAfterStyle = {};
        }
        return html `
      <inch-token-item-base
        .showIconAfter="${true}"
        .tokenNameText="${tokenName}"
        .tokenNetworkText="${tokenNetworkText}"
        .symbol="${symbol}"
        .walletAddress="${this.walletAddress}"
        .mobileView="${this.mobileView}"
        .chainIds="${chainIds}"
        .iconAfterStyle="${iconAfterStyle}"
        .additionalHeight="${size}"
        .selected="${this.expanded}"
        .iconAfterName="${'chevronDown16'}"
        @onClickIconAfter="${() => {
            changeExpand(this);
        }}"
        @onClickToken="${() => {
            changeExpand(this);
        }}"
      >
        <token-item-cross-chain-accordion-chain-list
          .favoriteTokenIds="${this.favoriteTokenIds}"
          .tokenIdListWithoutBalance="${tokenIdListWithoutBalance}"
          .tokenIdListWithBalance="${tokenIdListWithBalance}"
          .expanded="${this.expanded}"
          .showMoreChain="${this.showMoreChain}"
          .walletAddress="${this.walletAddress}"
          .showFavoriteTokenToggle="${this.showFavoriteTokenToggle}"
          .mobileView="${this.mobileView}"
          @changeExpandMore="${() => {
            this.showMoreChain = !this.showMoreChain;
        }}"
        ></token-item-cross-chain-accordion-chain-list>
      </inch-token-item-base>
    `;
    }
    // private renderChainList(
    //   tokenIdListWithoutBalance: TokenRecordId[],
    //   tokenIdListWithBalance: TokenRecordId[] | null
    // ) {
    //   return html`
    //     <div class="chain-list-view">
    //       ${map(
    //         tokenIdListWithBalance ?? [],
    //         (id) => html`
    //           <inch-token-item-cross-chain-accordion-chain-view
    //             class="token-with-balance"
    //             .showFavoriteTokenToggle="${this.showFavoriteTokenToggle}"
    //             .tokenId="${id}"
    //             .walletAddress="${this.walletAddress}"
    //             .mobileView="${this.mobileView}"
    //           ></inch-token-item-cross-chain-accordion-chain-view>
    //         `
    //       )}
    //       ${map(
    //         tokenIdListWithoutBalance,
    //         (id) => html`
    //           <inch-token-item-cross-chain-accordion-chain-view
    //             class="token-without-balance"
    //             .showFavoriteTokenToggle="${this.showFavoriteTokenToggle}"
    //             .tokenId="${id}"
    //             .walletAddress="${this.walletAddress}"
    //             .mobileView="${this.mobileView}"
    //           ></inch-token-item-cross-chain-accordion-chain-view>
    //         `
    //       )}
    //       ${when(
    //         tokenIdListWithBalance?.length,
    //         () => html`
    //           <inch-button
    //             class="more-chain-button"
    //             type="link"
    //             @click="${() => {
    //               this.showMoreChain = !this.showMoreChain
    //             }}"
    //           >
    //             <span class="less-more-icon-container">
    //               <inch-icon class="less-more-icon less-icon" icon="minus24"></inch-icon>
    //               <inch-icon class="less-more-icon more-icon" icon="plus24"></inch-icon>
    //             </span>
    //             <inch-text-animate text="${this.showMoreChain ? 'Less' : 'More'}">
    //             </inch-text-animate>
    //           </inch-button>
    //         `
    //       )}
    //     </div>
    //   `
    // }
    renderNetworkDescription(crossChainTokensBindingRecord) {
        return html `
      <span>
        ${crossChainTokensBindingRecord.tokenRecordIds.length}
        ${when(crossChainTokensBindingRecord.tokenRecordIds.length === 1, () => html `${translate('inch-token-item-cross-chain-accordion.network')}`, () => html `${translate('inch-token-item-cross-chain-accordion.networks')}`)}
      </span>
    `;
    }
};
__decorate([
    property({ type: Object, attribute: false }),
    __metadata("design:type", Object)
], TokenItemCrossChainAccordionElement.prototype, "crossChainTokensBindingRecord", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String)
], TokenItemCrossChainAccordionElement.prototype, "walletAddress", void 0);
__decorate([
    property({ type: Array, attribute: false }),
    __metadata("design:type", Array)
], TokenItemCrossChainAccordionElement.prototype, "showChainIds", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Object)
], TokenItemCrossChainAccordionElement.prototype, "showFavoriteTokenToggle", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Object)
], TokenItemCrossChainAccordionElement.prototype, "expanded", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Object)
], TokenItemCrossChainAccordionElement.prototype, "mobileView", void 0);
__decorate([
    property({ type: Number, attribute: false }),
    __metadata("design:type", Object)
], TokenItemCrossChainAccordionElement.prototype, "index", void 0);
__decorate([
    property({ type: Array, attribute: true }),
    __metadata("design:type", Array)
], TokenItemCrossChainAccordionElement.prototype, "favoriteTokenIds", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], TokenItemCrossChainAccordionElement.prototype, "showMoreChain", void 0);
TokenItemCrossChainAccordionElement = __decorate([
    customElement(TokenItemCrossChainAccordionElement.tagName)
], TokenItemCrossChainAccordionElement);
export { TokenItemCrossChainAccordionElement };
//# sourceMappingURL=token-item-cross-chain-accordion.element.js.map